import { create } from 'zustand';

type LoadingItem = {
    id: string;
    isLoading: boolean;
};

type UseLoadingStoreProps = {
    listLoading: LoadingItem[];
    getLoadingState: (id: string) => boolean | undefined;
    setLoadingState: (loadingItem: LoadingItem) => void;
};

export const useLoadingStore = create<UseLoadingStoreProps>((set, get) => ({
    listLoading: [],
    setLoadingState: (loadingItem: LoadingItem) => {
        const currentListLoading = get().listLoading;
        const itemIndex = currentListLoading.findIndex(
            (item) => item.id === loadingItem.id
        );

        if (itemIndex !== -1) {
            set({
                listLoading: currentListLoading.map((item, index) =>
                    index === itemIndex ? loadingItem : item
                ),
            });
            return;
        }

        set({
            listLoading: [...currentListLoading, loadingItem],
        });
    },
    getLoadingState: (id: string) =>
        get().listLoading.find((item) => item.id === id)?.isLoading,
}));
